import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=bef8718e&scoped=true&"
import script from "./Img.vue?vue&type=script&lang=ts&"
export * from "./Img.vue?vue&type=script&lang=ts&"
import style0 from "./Img.vue?vue&type=style&index=0&id=bef8718e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef8718e",
  null
  
)

export default component.exports